module.exports = "/_next/static/images/1aa4267d78303c188c8458f39535bd56-rewards-smiles@2x.png.webp";